






























import { Vue, Component, Prop } from 'vue-property-decorator'
import { date } from 'quasar'
import SearchResultsItem from 'components/presenter/search/SearchResultsItem.vue'
import confirm from 'components/modals/Confirm'
import api from 'src/assets/api/gql'
import TrashRemoveItem from 'src/graphql/search/TrashRemoveItem.gql'
import TrashRemoveStudentGroup from 'src/graphql/search/TrashRemoveStudentGroup.gql'
import TrashRemoveStudent from 'src/graphql/search/TrashRemoveStudent.gql'
import TrashRemoveSession from 'src/graphql/search/TrashRemoveSession.gql'
import TrashRestoreItem from 'src/graphql/search/TrashRestoreItem.gql'
import TrashRestoreStudentGroup from 'src/graphql/search/TrashRestoreStudentGroup.gql'
import TrashRestoreStudent from 'src/graphql/search/TrashRestoreStudent.gql'
import TrashRestoreSession from 'src/graphql/search/TrashRestoreSession.gql'
import { SearchResult, SearchResultType } from 'src/graphql/types'

@Component({
  components: {
    SearchResultsItem
  }
})
export default class PresenterSearchResultsList extends Vue {
  date = date
  loading = false

  @Prop()
  readonly found!: []

  async restore (item: SearchResult) {
    this.loading = true
    await api.mutate({
      query: this.getRestoreQuery(item),
      variables: {
        id: item.id
      }
    })
    this.loading = false
    this.$emit('remove', item)
    this.afterRestoreAction(item)
  }

  getRestoreQuery (item: SearchResult) {
    switch (item.type) {
      case SearchResultType.Student:
        return TrashRestoreStudent
      case SearchResultType.Group:
        return TrashRestoreStudentGroup
      case SearchResultType.Session:
        return TrashRestoreSession
      default:
        return TrashRestoreItem
    }
  }

  afterRestoreAction (item: SearchResult) {
    this.$emit('select')
    switch (item.type) {
      case SearchResultType.Attendee:
        if (item.path) {
          const sessionId = 0 // @todo: get session id
          return this.$router.replace('/presenter/session/' + sessionId + '/attendee/' + item.id)
        } else {
          break
        }
      case SearchResultType.Student:
        if (item.path) {
          const parentId = item.path.split('.').pop()
          return this.$router.replace('/presenter/' + parentId + '/student/' + item.id)
        } else {
          break
        }
      case SearchResultType.Group:
        if (item.path) {
          const parentId = item.path.split('.').pop()
          return this.$router.replace('/presenter/' + parentId + '/attendees/' + item.id)
        } else {
          break
        }
      case SearchResultType.Session:
        return this.$router.replace('/presenter/session/' + item.id)
      default:
        return this.$router.replace('/presenter/' + item.id)
    }
  }

  async remove (item: SearchResult) {
    await confirm({
      title: this.$t('trash.confirmitem').toString()
    })
    this.loading = true
    await api.mutate({
      query: this.getRemoveQuery(item),
      variables: {
        id: item.id
      }
    })
    this.loading = false
    this.$emit('remove', item)
  }

  getRemoveQuery (item: SearchResult) {
    switch (item.type) {
      case SearchResultType.Student:
        return TrashRemoveStudent
      case SearchResultType.Group:
        return TrashRemoveStudentGroup
      case SearchResultType.Session:
        return TrashRemoveSession
      default:
        return TrashRemoveItem
    }
  }
}
